import React from "react";

import { useTranslation } from "react-i18next";

import TrainingHub from "@/components/training/TrainingHub";

const RESPONSE_TEMPLATES_GUIDE_URL =
  "https://docs.google.com/document/d/e/2PACX-1vR_CCv76ZQvpNyMDVb_DZK7HBl8wdHUBNzrNufdnTDrYHxG71dbPv0hLYYIj-b1fmd8vRDNbP_LgXD1/pub";

const ReportV2Training: React.FC = () => {
  const { t } = useTranslation("training");

  return (
    <TrainingHub
      title={t("report.title")}
      sections={[
        {
          id: "adding-email-templates",
          heading: t("report.emailTemplatesHeading"),
          video: {
            title: t("report.emailTemplatesVideoTitle"),
            loomId: "ac9b65eef4fc4fcba203f309b9864e23",
            thumbnailUrl:
              "https://cdn.loom.com/sessions/thumbnails/ac9b65eef4fc4fcba203f309b9864e23-c5c88e0c7e593e86.jpg",
          },
          resources: [
            {
              title: t("report.responseTemplatesGuideTitle"),
              href: RESPONSE_TEMPLATES_GUIDE_URL,
              previewUrl: `${RESPONSE_TEMPLATES_GUIDE_URL}?embedded=true`,
            },
          ],
        },
      ]}
      support={{
        prefix: t("moreComingPrefix"),
        suffix: t("moreComingSuffix"),
        emailSubject: t("report.requestEmailSubject"),
        emailBody: t("report.requestEmailBody"),
      }}
    />
  );
};

export default ReportV2Training;
